import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  mimeTypeMapping,
  type FirestoreRoomStateFile,
} from '../firestore/RoomStateFile/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class RoomStateFile extends ObservableModelWithDecorators<FirestoreRoomStateFile> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRoomStateFile>
  ) {
    super(repository, doc)
  }

  mimeType() {
    if (this.data?.mimeType) return this.data.mimeType
    const extension = this.data?.fileName.split('.').pop() || ''
    return mimeTypeMapping[extension] || undefined
  }
}
